import { Layout } from 'antd'
import { useLocation } from 'react-router-dom'

import Footer from 'component/common/footer'
import Header from 'component/common/header'
import ModalProcess from 'component/modal/modal-process'
import ToastNoti from 'component/noti'
import Sidebar from 'component/sidebar-menu'
import { useConfigSetting } from 'hooks/setting/use-config-setting'
import LoginPage from 'pages/login'

const { Content } = Layout

function Main({ children }: any) {
  const location = useLocation()
  const pathUrl = location?.pathname.split('/')
  const pathLogin = pathUrl[1]

  // Load app config setting globally (ipfs_gateway_base_url, ...) into store
  useConfigSetting()

  return (
    <>
      {pathLogin === 'login' ? (
        <>
          <LoginPage />
        </>
      ) : (
        <>
          <Header />
          <div className="flex-layout">
            <div className="left">
              <Sidebar />
            </div>
            <div className="right">
              <Content style={{ padding: 20 }}>{children}</Content>
            </div>
          </div>
          <Footer />
          <ToastNoti />
          <ModalProcess />
        </>
      )}
    </>
  )
}

export default Main
